import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";

export const PLANS = {
  weekly: { id: "weekly", name: "Weekly", price: "$4.99", per: "week", charge: "You’re charged $4.99 today, then every week until you cancel." },
  monthly: { id: "monthly", name: "Monthly", price: "$14.99", per: "month", charge: "You’re charged $14.99 today, then every month until you cancel." },
};

export async function startPlanCheckout(planId) {
  const r = await api.post("/payments/checkout", { plan_id: planId, origin_url: window.location.origin });
  if (!r.data?.url) throw new Error("Could not start checkout");
  window.location.href = r.data.url;
}

// Pricing CTA: signed-in visitors go straight to checkout; others to signup with the plan pre-selected.
export function PlanCta({ planId, className, testId }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const plan = PLANS[planId];
  const label = `Start ${plan.name} — ${plan.price}`;
  const subscribed = user && (user.role === "admin" || user.role === "subscriber" || user.subscribed === true);
  if (!user || subscribed) {
    return (
      <Link to={subscribed ? "/app/account" : `/register?plan=${planId}`} className="block mt-8">
        <Button className={`w-full rounded-md ${className}`} data-testid={testId}>{subscribed ? "You’re subscribed — manage plan" : label}</Button>
      </Link>
    );
  }
  const go = async () => {
    setBusy(true);
    try {
      await startPlanCheckout(planId);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Checkout failed");
      setBusy(false);
    }
  };
  return (
    <Button onClick={go} disabled={busy} className={`w-full rounded-md mt-8 ${className}`} data-testid={testId}>
      {busy ? "Opening checkout…" : label}
    </Button>
  );
}
